import PdfReportActionTypes from './pdf-report.types';
import { generateAndSavePDFReport } from '../../services/server-api/server-api.service'

const fetchPdfReportRequest = () => ({
  type: PdfReportActionTypes.FETCH_PDF_REPORT_REQUEST
})

const fetchPdfReportSuccess = () => ({
  type: PdfReportActionTypes.FETCH_PDF_REPORT_SUCCESS
})

const fetchPdfReportFailure =(error) => ({
  type: PdfReportActionTypes.FETCH_PDF_REPORT_FAILURE,
  payload: error
})

export const fetchPdfReport = (params) => {
  return async dispatch => {
    dispatch(fetchPdfReportRequest())
    try {
      await generateAndSavePDFReport(params)
      dispatch(fetchPdfReportSuccess())
    } catch (error) {
      dispatch(fetchPdfReportFailure({ message: error.message, data: error.data}))
    }
  }
}